import dayjs from 'dayjs';
import Vue from 'vue';

import { getMedia } from '@modules/api/iptv';
import Guide from '@components/iptv/Index.vue';


Vue.mixin({
    methods: {
        async getMediaUrl(media, width, height = '', context = null) {
            if (!media) return '';

            // assets/s10057_ll_h15_ab.png?w=180&h=135 => s10057_ll_h15_ab.png
            const filename = media.match(/assets\/(\w*\.\w{3,4})\?/)[1];

            return await getMedia(filename, width, height, context)
                .then((response) => {
                    return response.uri;
                })
                .catch((error) => {
                    if (context) context.error = error;
                });
        }
    }
});

new Vue({
    el: '#vw-iptv',
    components: { Guide },
    data() {
        /*
        * const queryString = window.location.search;
        * const urlParams = new URLSearchParams(queryString);
        * const lineup = urlParams.get('lineup') ? urlParams.get('lineup') : '';
        */
        return {
            currentTime: dayjs(),
            defaultLogo: '/images/ontv-logo.webp',
            /** Width in pixel of the channels logos column */
            channelColumnWidth: 160,
            /** Individual timebar segments length in minutes */
            timebarItemLength: 15,
            coverLogo: '',
            baseFontSize: 20,
            imageSize: '',
            lineup: '',
            resolution: '',
            scrollOffset: 1,
            startTime: '',
            scheduleLength: 2,
            token: '',
            auth: '',
            loginUrl: '',
            registerUrl: '',
            dashboardUrl: '',
            DashboardText: '',
        }
    },
    computed: {
        /* The number of items/segments on the timebar is based on the provided
         `schedule_length`(converted in minutes) and the length of individual
          segments in minutes(in minutes).
        */
        timebarItemCount() {
            return (Number(this.scheduleLength) * 60) / this.timebarItemLength;
        },
    },
    beforeMount() {
        this.coverLogo = this.$el.parentNode.dataset.cover_logo;
        this.token = this.$el.parentNode.dataset.token;
        this.lineup = this.$el.parentNode.dataset.lineup;
        this.baseFontSize = Number(this.$el.parentNode.dataset.font_size);
        this.imageSize = this.$el.parentNode.dataset.image_size;
        this.screenPadding = Number(this.$el.parentNode.dataset.padding);
        this.resolution = this.$el.parentNode.dataset.resolution;
        this.scrollOffset = Number(this.$el.parentNode.dataset.scroll_offset);
        this.startTime = this.$el.parentNode.dataset.start_date;
        this.scheduleLength = Number(this.$el.parentNode.dataset.schedule_length);
        this.auth = this.$el.parentNode.dataset.auth ? true : false;
        this.loginUrl = this.$el.parentNode.dataset.login_url;
        this.registerUrl = this.$el.parentNode.dataset.register_url;
        this.dashboardUrl = this.$el.parentNode.dataset.dashboard_url;
        this.DashboardText = this.$el.parentNode.dataset.dashboard_text;
    },
    mounted() {

    },
    render(h) {
        return h('guide', {
            props: {
                coverLogo: this.coverLogo,
                token: this.token,
                lineup: this.lineup,
                baseFontSize: this.baseFontSize,
                imageSize: this.imageSize,
                screenPadding: this.screenPadding,
                resolution: this.resolution,
                scrollOffset: this.scrollOffset,
                startTime: this.startTime,
                scheduleLength: this.scheduleLength,
                auth: this.auth,
                loginUrl: this.loginUrl,
                registerUrl: this.registerUrl,
                dashboardUrl: this.dashboardUrl,
                DashboardText: this.DashboardText,
            }
        })
    }
});
